<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a report concern modal to go in the index
    *
    * @since 20210129
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <div class="modal fade" :id="modalId" role="dialog">
            <div class="modal-dialog modal-lg">       
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><span v-if="editing">Edit Reported</span><span v-else>Report New</span> Concern</h4>
                        <span v-if="saving">
                            <button type="button" class="close" data-dismiss="modal" disabled>Saving <i class="fas fa-sync fa-spin"></i></button>
                        </span>
                        <button v-else type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div v-if="pageOffline" class="modal-body">
                        You can't report a concern whilst on an offline page. Please reconnect to the internet or move to a different page before reporting your concern.
                    </div>
                    <div v-else-if="!hasLoaded" class="modal-body">
                        Please wait for the report a concern section to load <i class="fas fa-sync fa-spin"></i>
                    </div>
                    <div v-else class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                Please fill out as much of this form as you can. You do not have to fill it all out, but the more information you provide, the better we can deal with the concern. We may contact you to ask for more information. If you do now wish to be contacted, you can fill out this form anonymously by checking the 'post anonymously' check box at the bottom of the form.
                            </div>
                        </div>
                        <ul class="nav nav-tabs" id="nav-tab" role="tablist">
                            <li class="nav-item">
                                <a v-bind:class="['nav-link', 'active']" :id="'student-tab_' + modalId" data-toggle="tab" :href="'#student_' + modalId" role="tab" :aria-controls="'student_' + modalId" :aria-selected="'student_' + modalId">Select a Student</a>
                            </li>
                            <li v-for="form in forms" :key="form.form.id" class="nav-item">
                                <a :class="['nav-link']"  :href="form.hashed_tab_name + '_' + modalId" :id="form.tab_name_id + '_' + modalId" data-toggle="tab">{{form.form.title}}</a>
                            </li>
                        </ul>
                        <div class="tab-content mt-4" id="nav-tabContent">
                            
                            
                            <div v-bind:class="['tab-pane', 'fade', 'show active']" :id="'student_' + modalId" role="tabpanel" :aria-labelledby="'student-tab_' + modalId">
                                <div class="row">
                                    <div class="col-12">
                                        You can search for a student to make a report about using the below form. If you can't find the student you are looking for, or would rather just provide their name, you can switch to just entering the students name.
                                    </div>
                                    <div class="col-12"><br>
                                        <div class="form-group">
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input class="custom-control-input" type="radio" name="searchStudent" :id="'search1_' + modalId" value="1" v-model="searchStudent">
                                                <label class="custom-control-label" :for="'search1_' + modalId">Search For Student</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input class="custom-control-input" type="radio" name="searchStudent" :id="'search0_' + modalId" value="0" v-model="searchStudent">
                                                <label class="custom-control-label" :for="'search0_' + modalId">Enter Name</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="searchStudent == 1 && student === null" class="row">
                                    <div class="col-12">
                                        <list-view
                                            :title="search.title"
                                            :config='search.data.config'
                                            :records='search.data.data'
                                            :filters='search.data.filters'
                                            :service='search.service'
                                            area=""
                                        />
                                    </div>
                                </div>
                                <div v-else-if="searchStudent == 1" class="row">
                                    <div class="col-12">
                                        You have selected <b>{{student.first_name}} {{student.last_name}}</b>.
                                        <br /><span @click="selectStudent(null)">(if you want to select a different student, click here)</span>
                                    </div>
                                </div>
                                <div v-else class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="studentFirstName">First Name:</label>
                                            <input type="text" name="studentFirstName" class="form-control" v-model="studentFirstName">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="studentLastName">Last Name:</label>
                                            <input type="text" name="studentLastName" class="form-control" v-model="studentLastName">
                                        </div>
                                    </div>
                                </div>
                                <div v-if="this.forms.length > 0" class="row">
                                    <div class="col-12">
                                        <button type="button" class="btn btn-primary" :onclick="'$(\'#' + this.forms[0].tab_name_id + '_' + modalId + '\').tab(\'show\');'">Next <i class="fas fa-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div v-for="form in forms" :key="form.form.id + '_' + count" v-bind:class="['tab-pane', 'fade']" :id="form.tab_name + '_' + modalId" role="tabpanel" :aria-labelledby="form.tab_name_id + '_' + modalId">
                                <editable-form :ref="form.tab_name"
                                    :form="json_form(form)"
                                    :read_only="readOnly"
                                    :model_id="1"
                                ></editable-form>
                            </div>
                        </div>
                    </div>
                    <div v-if="!pageOffline && hasLoaded" class="modal-footer">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input class="custom-control-input" type="checkbox" name="accurate" id="accurate" v-model="accurate">
                                        <label class="custom-control-label" for="accurate">I confirm that all of the information provided is accurate</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input class="custom-control-input" type="checkbox" name="anon" id="anon" v-model="anon">
                                        <label class="custom-control-label" for="anon">Post Anonymously</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span v-if="!readOnly">
                            <span v-if="saving">
                                <button type="button" @click="save_concern" class="btn btn-primary" disabled>Reporting <i class="fas fa-sync fa-spin"></i></button>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal" disabled>Close without Reporting</button>
                            </span>
                            <span v-else>
                                <button type="button" @click="save_concern" class="btn btn-primary"><i class="fa fa-floppy-o fa-lg pr-1"></i>Report</button>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fas fa-times pr-1"></i>Close without Reporting</button>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import loadcomponents from './loadcomponents'
    export default{
        
        props: {
            getRoute: String,
            data: Object,
            //js scripts to load
            scriptsToLoad: {
                type: Array
            },
        },
        created() {
            var routes = localStorage.getItem("offline_routes");
            if(routes === null){
                routes = [];
            } else {
                routes = JSON.parse(routes)
            }
            if(this.getRouteIndex(routes, window.location.href) >= 0){
                this.pageOffline = true;
            }
            if(this.data !== undefined){
                this.setData(this.data);
                this.hasLoaded = true;
            }
        },
        data() {
            return {
                hasLoaded: false,
                loading: false,
                store_route: '',
                saving: false,
                route: '',
                editing: false,
                anon: false,
                accurate: false,
                studentFirstName: '',
                studentLastName: '',
                searchStudent: 1,
                student: null,
                readOnly: false,
                count: 1,
                baseForms: [],
                forms: [],
                modalId: 1,
                updateList: [],
                pageOffline: false,
                search: {
                    title: '',
                    data: {
                        config: {
                            struct: {
                                
                            },
                            showArchived: 'no',
                            filtersVisible: false,
                            simplePage: true
                        },
                        data: {
                            rows: [],
                            pagination: {
                                page: 1,
                                currPageCount: 0,
                                limit: 25,
                                recordCount: 0,
                                pages: 1,
                                pagerSize: 5
                            },
                        },
                        filters: {
                            uiSchema: [{
                                children: []
                            }]
                        }
                    },
                    service: '',
                }
            }
        },
        computed: {
        },
        methods: {
            /**
             * shows the concern modal
             * 
             * @param Object concern the concern to display on the modal
             */
            show_concern_modal: function(concern=null){
                
                this.count++;
                if(concern !== null){
                    this.editing = true;
                    this.route = concern.route;
                    this.forms = concern.forms;
                    this.student = concern.student;
                    this.searchStudent = concern.student_id !== null ? 1 : 0;
                    this.studentFirstName = concern.dataOb.first_name;
                    this.studentLastName = concern.dataOb.last_name;
                    this.anon = concern.reported_by === null;
                    this.accurate = true;
                    this.readOnly = concern.deleted_at !== null;
                } else {
                    this.route = this.store_route;
                    this.editing = false;
                    this.forms = this.baseForms;
                    this.student = null;
                    this.searchStudent = 1;
                    this.studentFirstName = '';
                    this.studentLastName = '';
                    this.anon = false;
                    this.accurate = false;
                    this.readOnly = false;
                }
                $('#student-tab_' + this.modalId).tab('show');
                $('#' + this.modalId).modal('show');
                if(!this.hasLoaded && !this.pageOffline){
                    this.getData()
                } else {
                    loadcomponents.loadComponents(this.scriptsToLoad);
                }
            },
            /**
            * gets the data for the tab
            */
            getData: async function (refresh = false) {
                if((!this.hasLoaded || refresh) && !this.loading){
                    this.loading = true;
                    if(refresh){
                        this.hasLoaded = false;
                    }
                    try {
                        const { data } = await this.$http.get(this.getRoute);
                        
                        if(data.error !== undefined){
                            console.log('An error occurred getting the data');
                            console.log(data.error);
                        } else if(data !== undefined){
                            this.setData(data);
                            var self = this;
                            loadcomponents.loadComponents(this.scriptsToLoad, function(){
                                self.hasLoaded = true;
                            });
                        } else {
                            console.log(data);
                        }
                    } catch(error) {
                        console.log('An error occurred getting the data');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    }
                    this.loading = false;
                }
            },
            setData: function(data){
                this.store_route = data.storeRoute;
                this.route = data.storeRoute;
                this.baseForms = data.forms;
                this.forms = data.forms;
                this.modalId = data.modalId;
                this.updateList = data.updateList;
                this.search.service = data.searchRoute;
            },
            /**
             * saves the concern modal
             */
            save_concern: async function (){
                if(!this.accurate){
                    alert('Please confirm that the information provided is accurate.')
                    return false;
                }
                this.saving = true;
                $('#' + this.modalId).data('bs.modal')._config.backdrop = 'static';
                $('#' + this.modalId).data('bs.modal')._config.keyboard = false;
                var save_params = {
                    anon: this.anon,
                    accurate: this.accurate,
                    studentFirstName: this.studentFirstName,
                    studentLastName: this.studentLastName,
                    searchStudent: this.searchStudent,
                    studentId: this.student !== null ? this.student.id : 0,
                }
                for(var i=0; i<this.forms.length; i++){
                    save_params[this.$refs[this.forms[i].tab_name][0].form_data_name] = this.$refs[this.forms[i].tab_name][0].form_data_string;
                }
                this.error_occured = false;
                var self = this;
                if(!this.editing){
                    try {
                        const { data } = await this.$http.post(
                            this.route, 
                            save_params
                        );
                        if(data.error !== undefined){
                            self.error_occured = true;
                            console.log('An error occurred saving the concern');
                            console.log(data.error);
                            alert('An error occurred saving the concern');
                        } else if(data !== undefined){
                            if(self.updateList){
                                self.$parent.listItems.unshift(response.data);
                            }
                        } else {
                            console.log(data);
                        }  
                    } catch(error) {
                        self.error_occured = true;
                        
                        console.log('An error occurred saving the concern');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                        alert('An error occurred saving the concern');
                    }
                    self.saving = false;
                    $('#' + self.modalId).data('bs.modal')._config.backdrop = true;
                    $('#' + self.modalId).data('bs.modal')._config.keyboard = true;
                    $('#' + self.modalId).modal('hide');
                } else {
                    try {
                        const { data } = await this.$http.put(
                            this.route, 
                            save_params
                        );
                        if(data.error !== undefined){
                            self.error_occured = true;
                            console.log('An error occurred saving the concern');
                            console.log(data.error);
                            alert('An error occurred saving the concern');
                        } else if(data !== undefined){
                            if(self.updateList){
                                var arr = [];
                                for(var i=0; i<self.$parent.listItems.length; i++){
                                    if(self.$parent.listItems[i].id == data.id){
                                        arr.push(data);
                                    } else {
                                        arr.push(self.$parent.listItems[i]);
                                    }
                                }
                                self.$parent.listItems = arr;
                            }
                        } else {
                            console.log(data);
                        }  
                    } catch(error) {
                        self.error_occured = true;
                        
                        console.log('An error occurred saving the concern');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                        alert('An error occurred saving the concern');
                    }
                    self.saving = false;
                    $('#' + self.modalId).data('bs.modal')._config.backdrop = true;
                    $('#' + self.modalId).data('bs.modal')._config.keyboard = true;
                    $('#' + self.modalId).modal('hide');
                }
                
            },
            /**
             * deletes the concern modal
             * 
             * @param Object concern the concern to destroy
             */
            async destroy_concern (concern){
                if(confirm('Are you sure that you want to delete this concern?')){
                    concern.deleting = true;
                    this.error_occured = false;
                    const { data } = await this.$http.delete(
                        concern.destroy_route, 
                        { 
                            
                        }
                    ).catch((error) => {
                        this.error_occured = true;
                        console.log('An error occurred deleting the concern');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    });
                    if(!this.error_occured){
                        if(data.error !== undefined){
                            this.error_occured = true;
                            console.log('An error occurred deleting the concern');
                            console.log(data.error);
                        } else {
                            if(this.updateList){
                                var arr = [];
                                for(var i=0; i<this.$parent.listItems.length; i++){
                                    if(this.$parent.listItems[i].id == data.id){
                                    } else {
                                        arr.push(this.$parent.listItems[i]);
                                    }
                                }
                                this.$parent.listItems = arr;
                            }
                        }
                    }
                    concern.deleting = false;
                }
            },
            selectStudent: function(student){
                this.student = student;
                if(student !== null){
                    this.studentFirstName = student.first_name;
                    this.studentLastName = student.last_name;
                }
            },
            /**
             * formats a date for displaying
             * 
             * @param Date dt the date to display
             * @returns String the formatted date
             */
            formatdate: function (dt){
                var date = new Date(dt);
                var day = date.getDate() + '';
                if(day.length == 1){
                    var day = '0' + day;
                }
                var month = (date.getMonth()+1) + '';
                if(month.length == 1){
                    var month = '0' + month;
                }
                return day + '/' + month + '/' + date.getFullYear();
            },
            generate_list: function (concern_list, all_list, year_group=false){
                var arr = [];
                for(var j=0; j<concern_list.length; j++){
                    for(var i=0; i<all_list.length; i++){
                        if(year_group){
                            if(all_list[i].id == concern_list[j].year_group){
                                arr.push(all_list[i]);
                            }
                        } else {
                            if(all_list[i].id == concern_list[j].id){
                                arr.push(all_list[i]);
                            }
                        }
                    }
                }
                return arr;
            },
            json_form: function(form){
                return JSON.stringify(form);
            },
            getRouteIndex: function(routes, route){
                for(var i=0; i<routes.length; i++){
                    if(routes[i].route == route){
                        return i;
                    }
                }
                return -1;
            },
        }
    }
</script>